import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../style-class'
import { ZINDEX_0, ZINDEX_9 } from '../__constants/z-index'

/* Types ======================================================================================== */
type ClassNames = {
  /**
   * Base class for float dialog
   */
  base: string
  /**
   * Proped class for float dialog
   */
  proped: {
    open: string
    fullWidth: string
  }
  /**
   * Base class for content
   */
  contentBase: string

  contentProped: {
    fullWidth: string
  }
}

type ClassProps = {}

const getNames: (props: ClassProps, theme: any) => ClassNames = (props, theme) => {
  const base = style({
    opacity: 0,
    overflow: 'hidden',
    position: 'fixed',
    transition: theme.transition.fast,
    transitionProperty: 'opacity',
    visibility: 'hidden',
    zIndex: ZINDEX_9,
  })

  const proped = {
    open: style({
      opacity: 1,
      overflow: 'initial',
      visibility: 'visible',
      zIndex: ZINDEX_9,
    }),
    fullWidth: style({
      width: '100%',
    }),
  }

  const contentBase = style({
    position: 'absolute',
    width: 'fit-content',
    background: 'white',
  })

  const contentProped = {
    fullWidth: style({
      width: '100% !important',
    }),
  }

  return {
    base,
    proped,
    contentBase,
    contentProped,
  }
}

/* Export ======================================================================================= */
export const floatDialogClass = new StyleClass<ClassNames, ClassProps>(getNames)
